import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { translate } from 'react-i18nify';
import SessionModal from '../components/SessionModal';
import Auth from '../lib/Auth';

import {
  showSessionModal,
  refreshSession,
  closeSessionModal,
} from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  title: translate('shared.sessionRefresh'),
  showModal: state.account.sessionToken.show,
  processing: state.account.sessionToken.processing,
  saveBtnText: translate('shared.refresh'),
  content: translate('shared.sessionRefreshPrompt'),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  buttonAction: () => {
    dispatch(refreshSession());
    const dtoken = Auth.get_sso_token();
    if (Auth.timer) {
      clearTimeout(Auth.timer);
    }
    setTimeout(() => {
      dispatch(showSessionModal());
    }, (dtoken['exp'] - dtoken['auth_time']) * (3 / 4) * 1000);
  },
  closeDialog: () => {
    dispatch(closeSessionModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SessionModal));
